module.exports = __webpack_public_path__ + "static/media/icon_is_empty.d5c920ef.svg";